var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "TcTest container mx-auto p-5" }, [
    _c("h2", { staticClass: "text-center" }, [_vm._v("TcTest")]),
    _vm._v(" "),
    _c("div", { domProps: { textContent: _vm._s(_vm.token) } }),
    _vm._v(" "),
    _c("div", { domProps: { textContent: _vm._s(_vm.create_ticket_url) } }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.event_id,
          expression: "event_id"
        }
      ],
      domProps: { value: _vm.event_id },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.event_id = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c("button", { on: { click: _vm.postEvent } }, [_vm._v("Crear")]),
    _vm._v(" "),
    _c("pre", { staticClass: "text-xs" }, [
      _vm._v(_vm._s(JSON.stringify(_vm.$root.user, null, 2)))
    ]),
    _vm._v(" "),
    _c("pre", { staticClass: "text-xs" }, [
      _vm._v(_vm._s(JSON.stringify(_vm.out, null, 2)))
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "fixed z-10 inset-0 overflow-y-auto",
        attrs: {
          "aria-labelledby": "modal-title",
          role: "dialog",
          "aria-modal": "true"
        }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
          },
          [
            _c("div", {
              staticClass:
                "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "hidden sm:inline-block sm:align-middle sm:h-screen",
                attrs: { "aria-hidden": "true" }
              },
              [_vm._v("​")]
            ),
            _vm._v(" "),
            true
              ? _c("TcInscriptionConfirm", {
                  attrs: {
                    event: _vm.event,
                    guests: _vm.guests,
                    children: _vm.children,
                    companions: _vm.companions
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            false ? _c("TcInscriptionSuccess") : _vm._e(),
            _vm._v(" "),
            false ? _c("TcInscriptionError") : _vm._e()
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }